/* ============================================================
   CDS — Textify JS Override (version SAFE, anti-freeze)
   Studio  : Chlo' Design Studio
   Client  : Les étoiles s'alignent
   Desc.   : Textify applique « background: #F5E1C9 !important » EN INLINE
             sur ses champs texte. Un !important inline bat un !important
             de feuille de style → impossible à corriger en CSS pur.
             Ce script réécrit le background inline vers la couleur DA CDS.

   IMPORTANT : on N'OBSERVE PAS les attributs sur tout le body (Textify
   modifie ses styles en continu → boucle infinie / page gelée).
   On se contente de :
     - quelques passes au chargement + timers
     - un observer childList DÉBOUNCÉ (détecte l'injection des champs)
     - un re-style léger sur focusin (quand un champ conditionnel s'ouvre)
   ============================================================ */
(function () {
  'use strict';

  var BG = '#fdf8f3';
  var BG_RGB = 'rgb(253, 248, 243)';

  var SELECTOR = [
    '[id*="textFieldTextArea"]',
    '[id*="_textFieldDiv_"] textarea',
    '[id*="_textFieldDiv_"] input[type="text"]'
  ].join(',');

  function fixField(el) {
    /* early-return si déjà bon → aucune écriture inutile */
    try {
      if (window.getComputedStyle(el).backgroundColor === BG_RGB) return;
    } catch (e) {}
    el.style.setProperty('background', BG, 'important');
    el.style.setProperty('background-color', BG, 'important');
    el.style.setProperty('background-image', 'none', 'important');
  }

  function fixAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) fixField(nodes[i]);
  }

  /* Débounce : un burst de mutations = un seul fixAll (évite le freeze) */
  var debTimer = null;
  function fixAllDebounced() {
    if (debTimer) return; /* déjà planifié */
    debTimer = setTimeout(function () {
      debTimer = null;
      fixAll();
    }, 200);
  }

  function init() {
    fixAll();

    /* Observer UNIQUEMENT childList (injection des champs), JAMAIS les attributs.
       Débouncé pour ne pas spammer pendant que Textify construit son DOM. */
    if ('MutationObserver' in window && document.body) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            fixAllDebounced();
            return;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    /* Re-style léger quand un champ reçoit le focus (Textify peut réécrire son fond) */
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches(SELECTOR)) fixField(e.target);
    });

    /* Quelques passes de sécurité (Textify charge tard) — bornées, pas de boucle */
    setTimeout(fixAll, 500);
    setTimeout(fixAll, 1500);
    setTimeout(fixAll, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', fixAll);
})();
